<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility" tabindex="-1" pplAutoFocusHeader>{{source | titlecase}} Adjustment Approvals</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-timesheet-filter [filterFields]="fields" [chequeNumbers]="chequeNumbers"
                        (searchEvent)="onSearch($event)"></ppl-timesheet-filter>
                    <p class="pl-2"> <span class="error-message1" [attr.aria-label]="'Required'">*</span> At least one out of the following fields
                        should be populated: <b>Consumer Name</b>, <b>Consumer PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>.
                    </p>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Approve</strong> and <strong>Reject</strong> actions, please select the
                                applicable timesheet.</li>
                            <li>The <strong>Approve All</strong> and <strong>Reject All</strong> actions will update all
                                timesheets that match the search criteria OR all the selected timesheets.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(timesheets.length > 0) {
                    <ppl-list-table [actionButtons]="actionButtons" rowDataAccessibilityKey="tas_timesheetline_detail_id" (actionInvoked)="gridAction($event)" [cols]="cols"
                        [customDataLoaded]="true" [data]="timesheets" [disableSearch]="true" [disableSort]="true"
                        [enableActions]="false" [enablePageActions]="true" [from]="'timesheet'" [gridTitle]="false"
                        [lineItemCols]="lineItemCols" [listButton]="buttons" [loadPage]="true" [pagination]="true"
                        (rowDetailEvent)="rowExpanded($event)" [showCustomSearch]="false" [showExpandIcon]="true"
                        [showLineItem]="true" [showLineItemActions]="false" [timesheetFor]="'pendedTimesheet'">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ppl-popup-dialog [(isVisible)]="showActionPopup" [title]="title" [showButtons]="false" [showOkButton]="false"
    [showClose]="true" [size]="'medium'" [position]="'center'">
    <div class="p-10">
        <form nz-form nz-row [formGroup]="approvalTimesheetForm" class="ppl-p0 mt-2">
            <table class="table">
                <thead>
                    <tr>
                        <th style="background-color: #a8e4e14d; width: 25%;">{{this.commentText}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input class="contrast-colors" formControlName="comments" nz-input id="comments"  aria-label="Comments"
                                [nzStatus]="approvalTimesheetForm.get('comments')?.invalid && approvalTimesheetForm.get('comments')?.touched ? 'error' : ''" />
                            <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                                *ngIf="approvalTimesheetForm.get('comments')?.invalid && approvalTimesheetForm.get('comments')?.touched">
                                <div class="error-message">Please add the reject comments.</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="this.isDialogNoteDisplayed" class="alert alert-warning">
                <strong>{{this.dialogNoteMessage}}</strong>
            </div>
            <div class="custom-row w-100">
                <ppl-button (click)="onSave()" style="margin-right: 8px;" label={{dialogButtonLabel}}
                    icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
            </div>
        </form>
    </div>
</ppl-popup-dialog>

<div class="filter-panel">
    <ng-template #searchFilterWarningDialog let-cancel="cancel">
        <p> At least one out of the following fields should be populated: Consumer Name, Consumer PPL ID, Provider Name,
            Provider PPL ID</p>
    </ng-template>
</div>